import log from 'salvo-lite/log'
import AjaxCart from '../helpers/AjaxCart'

class QuickBuy {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._addToCartBtn = elem.querySelector('data-add-to-cart')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('click', e => {
            if (e.target.hasAttribute('data-add-to-cart')) {
                this._addToCart()
            }
        })
    }

    async _addToCart () {
        const quantity = 1
        const selectedVariant = parseInt(this._elem.querySelector('select[name="id"]').value)
        const payload = {quantity, id: selectedVariant}
        await AjaxCart.addItem(payload)
    }
}

export default QuickBuy



// WEBPACK FOOTER //
// ./src/resources/scripts/components/QuickBuy.js